import React from 'react';
import { Category } from '../Category';

import c from './category-group.module.scss';
import { Icon as LibraryIcon } from '@monash/portal-react';

const CategoryGroup = ({ type, categories }) => {
  return (
    <div className={c.categoryGroup}>
      <h3>{`Browse by ${type}`}</h3>
      <ul>
        {categories?.map((item, i) => {
          const Icon = LibraryIcon[item.icon];

          return (
            <Category
              name={item.title}
              icon={<Icon />}
              to={item.path}
              key={item.name + i}
            />
          );
        })}
      </ul>
    </div>
  );
};

export default CategoryGroup;
